module.exports = __webpack_public_path__ + "static/img/iframe.1ed61ea.png";